module.exports = __webpack_public_path__ + "img/create-xrp-filter.b7838f17.png";